import styled from "styled-components"

export interface StyledModalProps {
  visible: boolean
  noTitle: boolean
}

export const StyledModal = styled.div<StyledModalProps>`
  width: 100%;
  min-height: 100vh;
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: calc(64px + 26px) 32px 64px 32px;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: calc(54px + 16px) 0 48px 0;
  }

  & .sentinal {
    height: 116px;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
      height: 87px;
    }
  }
`
export const StyledModalMain = styled.div`
  max-width: ${(props) => props.theme.breakPoints.desktop};
  width: 100%;
  position: relative;
  z-index: 2;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0 0 16px ${(props) => props.theme.colors.darkGrey10};
`
export const StyledModalHeader = styled.header`
  z-index: 3;
`

export const StyledModalHeaderTop = styled.div`
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translateY(-50%);
`
export const StyledModalHeaderArrow = styled.div`
  cursor: pointer;
  margin: 0 24px 0;
`
export const StyledModalTitle = styled.p`
  ${(props) => props.theme.mixins.heading}
  margin-top: 0;
`
export const StyledModalNav = styled.nav<StyledModalProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -26px;
  padding: 16px 24px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 16px 16px 0px ${(props) => props.theme.colors.darkGrey05};
  position: sticky;
  width: 100%;
  z-index: 10;
  max-width: 1024px;
  top: 0;
  left: 50%;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    margin-top: -19px;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 16px;
    overflow: scroll;
    width: 100%;
    left: 0;
    justify-content: flex-start;
    background: ${(props) => props.theme.colors.white};
    ${(props) => props.noTitle && `background: transparent; box-shadow: none;`};
  }

  & a {
    padding: 8px;
    cursor: pointer;
    ${(props) => props.theme.mixins.bold}
    opacity: .8;
    text-decoration: none;
    white-space: nowrap;

    &:hover {
      opacity: 1;
    }
  }
  ${(props) =>
    props.stuck &&
    `
        @media (max-width: ${props.theme.breakPoints.tablet}) {
            padding: 16px 86px 16px 16px;
        }
    `}
`
export const StyledModalContent = styled.div<StyledModalProps>`
  padding-top: ${(props) => props.noTitle && `16px`};
  /* padding: 32px;
    @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
        padding: 24px;
    } */
`
export const StyledModalBG = styled.div`
  background: ${(props) => props.theme.colors.ivory};
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`
export const StyledModalClose = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0 0 16px ${(props) => props.theme.colors.darkGrey10};
  border: 0;
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  & svg {
    color: ${(props) => props.theme.colors.darkGrey};
  }

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    background: transparent;
    box-shadow: none;
    height: auto;
    width: auto;
    top: 16px;
    right: 16px;

    & i {
      svg {
        max-width: 16px;
        min-width: 16px;
        max-height: 16px;
        min-height: 16px;
      }
    }
  }
`
